import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
  baseURL: `${BASE}/api`,
  timeout: 20000,
});

export const Arma = {
  health: () => api.get("/health").then((r) => r.data),
  currentMap: (instance) =>
    api.get("/current-map", { params: instance ? { instance } : {} }).then((r) => r.data),
  instances: () => api.get("/instances").then((r) => r.data),

  branding: () => api.get("/branding").then((r) => r.data),
  updateBranding: (formData) =>
    api.post("/branding", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  deleteLogo: () => api.delete("/branding/logo").then((r) => r.data),
  deleteBackground: () => api.delete("/branding/background").then((r) => r.data),

  dashboardSummary: (instance) =>
    api.get("/dashboard/summary", { params: { instance } }).then((r) => r.data),
  killfeed: (instance, limit = 20) =>
    api.get("/dashboard/killfeed", { params: { instance, limit } }).then((r) => r.data),
  chat: (instance, limit = 30) =>
    api.get("/dashboard/chat", { params: { instance, limit } }).then((r) => r.data),
  bases: (instance) =>
    api.get("/dashboard/bases", { params: { instance } }).then((r) => r.data),
  vehicles: (instance) =>
    api.get("/dashboard/vehicles", { params: { instance } }).then((r) => r.data),

  scoreboard: (instance, range = "all") =>
    api.get("/scoreboard", { params: { instance, range } }).then((r) => r.data),

  heatmap: (params) => api.get("/heatmap", { params }).then((r) => r.data),

  liveMap: (instance) =>
    api.get("/live-map", { params: { instance } }).then((r) => r.data),
};

export function backendOrigin() {
  return BASE;
}
